import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=4e128e93&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=ts"
export * from "./ImageView.vue?vue&type=script&lang=ts"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=4e128e93&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e128e93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e128e93')) {
      api.createRecord('4e128e93', component.options)
    } else {
      api.reload('4e128e93', component.options)
    }
    module.hot.accept("./ImageView.vue?vue&type=template&id=4e128e93&scoped=true", function () {
      api.rerender('4e128e93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ImageView.vue"
export default component.exports